import React, { Component } from "react";
import "./MAMCAResult.css";
import Cookie from 'js-cookie';
import {
    message, Divider, Spin,
    Button, Steps, Row, Col,
    InputNumber, Form, Tabs, Icon,
    Menu, Dropdown

} from 'antd';
import { Link } from "react-router-dom";
import ReactEcharts from 'echarts-for-react';
// import { jsPDF } from "jspdf";
// import autoTable from 'jspdf-autotable';
// import { prepareBoxplotData } from 'echarts/extension/dataTool';
// Import XLSX and FileSaver libraries
// import * as XLSX from 'xlsx';
import * as XLSX from "sheetjs-style";

import { saveAs } from 'file-saver';

var echarts = require("echarts");
// echarts.dataTool = require("echarts/extension/dataTool"); //import dataTool
const TabPane = Tabs.TabPane;

export default class MAMCAResult extends Component {
    constructor(props) {
        super(props);

        const panes = [
            { title: 'Tab 1', key: '1' },
        ];
        let menu = ( //evaluator list default
            <Menu>
                <Menu.Item key="1">
                    <Icon type="user" />
                    1st menu item
                </Menu.Item>
                <Menu.Item key="2">
                    <Icon type="user" />
                    2nd menu item
                </Menu.Item>
                <Menu.Item key="3">
                    <Icon type="user" />
                    3rd item
                </Menu.Item>
            </Menu>
        );

        this.state = {
            email: Cookie.get("email"),
            activeKey: Cookie.get('activeKey'),
            loading: true, //the loading status default true
            project: {},
            number: 0,
            panes,
            activeKey: '1',
            changedName: "",
            chart: "Overall result",
            selectedCriterion: "",
            selectedEvaluator: Cookie.get("email"),
            menu: menu,
        };
    }

    onStepChange = current => {
        if (current === 0) {
            this.props.history.push(`/alternative/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 1) {
            this.props.history.push(`/mamcaactors/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 2) {
            this.props.history.push(`/mamcacriteria/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 3) {
            this.props.history.push(`/mamcaweight/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 4) {
            this.props.history.push(`/mamcaevaluation/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
    }

    handleMenuClick = (e) => {
        this.setState({
            selectedEvaluator: e.key,
        });
    }

    onChange = (activeKey) => {
        Cookie.set('activeKey', activeKey);
        let menuList = []
        let menu
        let selectedEvaluator = Cookie.get("email")
        if (this.state.project.projectActorGroup[activeKey - 1].actorCriteria[0]) {
            if (this.state.project.projectActorGroup[activeKey - 1].actorCriteria[0].actors && this.state.project.projectActorGroup[activeKey - 1].actorCriteria[0].actors.length !== 0) { //there are actors
                selectedEvaluator = this.state.project.projectActorGroup[activeKey - 1].actorCriteria[0].actors[0].actorEvaluator
                this.state.project.projectActorGroup[activeKey - 1].actorCriteria[0].actors.forEach(aobj => {
                    let menuItem = (
                        <Menu.Item key={aobj.actorEvaluator}>
                            <Icon type="user" />
                            {aobj.actorEvaluator}
                        </Menu.Item>
                    )
                    menuList.push(menuItem)
                })
            }
            menu = ( //evaluator list default
                <Menu onClick={this.handleMenuClick}>
                    {menuList}
                </Menu>
            );
        }
        else {
            menu = ( //evaluator list default
                <Menu onClick={this.handleMenuClick}>
                    <Menu.Item key={Cookie.get("email")}>
                        <Icon type="user" />
                        {Cookie.get("email")}
                    </Menu.Item>
                </Menu>
            )
        }
        this.setState({
            menu: menu,
            activeKey: activeKey,
            selectedCriterion: "",
            selectedEvaluator: selectedEvaluator,
        });
    }

    handleNumberChange = (value) => {
        let sProject = this.state.project
        let prop = 0
        let criterion = ""
        sProject.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(obj => { //change weight


            if (obj.criteriaName === this.state.changedName) { //this is criterion
                obj.actors.forEach(aobj => {

                    if (aobj.actorEvaluator === this.state.selectedEvaluator) {

                        prop = (1 - value) / (1 - aobj.actorCriteriaWeight)
                        aobj.actorCriteriaWeight = value
                    }
                })
                // prop = (1 - value) / (1 - obj.criteriaWeight)
                // obj.criteriaWeight = value
            }




        })

        sProject.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(obj => { //set new weight

            if (obj.criteriaName !== this.state.changedName && obj.criteriaName !== criterion) { //this is criterion
                obj.actors.forEach(aobj => {
                    if (aobj.actorEvaluator === this.state.selectedEvaluator) {
                        aobj.actorCriteriaWeight = aobj.actorCriteriaWeight * prop

                    }
                })
                //  obj.criteriaWeight = obj.criteriaWeight * prop
            }

        })


        if (value >= 0.1 && value <= 0.9) {

            this.setState({
                number: value,
                project: sProject,
            })
        }
    }

    getMAMCAOverallResult = () => {
        let actorName = [];
        let lineSymbol = ['circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'];
        let num = 0;
        let seriesData = [];
    
        // Gather actor group names
        if (this.state.project.projectActorGroup) {
            this.state.project.projectActorGroup.forEach(obj => {
                actorName.push(obj.actorGroupName);
            });
        }
    
        if (this.state.project.projectAlternatives) {
            this.state.project.projectAlternatives.forEach(alternative => {
                let line = {};
                let lineData = [];
    
                // Loop through each actor group to calculate the overall score
                this.state.project.projectActorGroup.forEach(actorGroup => {
                    let overallScore = 0; // To store final score
                    let totalWeight = 0; // Track the total weight for normalizing
    
                    if (actorGroup.actorCriteria && actorGroup.actorCriteria.length > 0) {
                        // For each criterion
                        actorGroup.actorCriteria.forEach(criterion => {
                            let criterionWeightSum = 0;
                            let criterionWeightCount = 0;
                            let criterionAvgWeight = 0;
                            let alternativeScoreSum = 0;
    
                            // Sub-criteria exists
                            if (criterion.subCriteria && criterion.subCriteria.length > 0) {
                                criterion.subCriteria.forEach(subCriterion => {
                                    let subCriterionWeightSum = 0;
                                    let subCriterionWeightCount = 0;
                                    let subCriterionScoreSum = 0;
    
                                    // Sum the weights and scores for sub-criteria
                                    subCriterion.actors.forEach(subActor => {
                                        let mainActor = criterion.actors.find(a => a.actorEvaluator === subActor.actorEvaluator);
                                        let mainWeight = mainActor ? parseFloat(mainActor.actorCriteriaWeight) : 0;
                                        let subWeight = subActor ? parseFloat(subActor.actorSubCriteriaWeight) : 0;
                                        let finalWeight = mainWeight * subWeight;
    
                                        if (!isNaN(finalWeight)) {
                                            subCriterionWeightSum += finalWeight;
                                            subCriterionWeightCount++;
                                        }
    
                                        // Sum the scores for this alternative under the sub-criteria
                                        subActor.actorSubCriteriaResult.forEach(result => {
                                            if (result.subCriteriaAlternativeName === alternative.alternativeName) {
                                                subCriterionScoreSum += result.subCriteriaAlternativeScore;
                                            }
                                        });
                                    });
    
                                    // Average sub-criteria weight and score
                                    let avgSubCriterionWeight = subCriterionWeightCount > 0 ? subCriterionWeightSum / subCriterionWeightCount : 0;
                                    let avgSubCriterionScore = subCriterionWeightCount > 0 ? subCriterionScoreSum / subCriterionWeightCount : 0;
    
                                    // Add to overall weighted score
                                    overallScore += avgSubCriterionWeight * avgSubCriterionScore;
                                    totalWeight += avgSubCriterionWeight;
                                });
                            } else {
                                // No sub-criteria, use main criteria weights and scores
                                criterion.actors.forEach(actor => {
                                    let weight = actor.actorCriteriaWeight ? parseFloat(actor.actorCriteriaWeight) : 0;
                                    criterionWeightSum += weight;
                                    criterionWeightCount++;
    
                                    actor.actorCriteriaResult.forEach(result => {
                                        if (result.criteriaAlternativeName === alternative.alternativeName) {
                                            alternativeScoreSum += result.criteriaAlternativeScore;
                                        }
                                    });
                                });
    
                                // Average weight and score for this criterion
                                criterionAvgWeight = criterionWeightCount > 0 ? criterionWeightSum / criterionWeightCount : 0;
                                let avgAlternativeScore = criterionWeightCount > 0 ? alternativeScoreSum / criterionWeightCount : 0;
    
                                // Add to the overall score
                                overallScore += criterionAvgWeight * avgAlternativeScore;
                                totalWeight += criterionAvgWeight;
                            }
                        });
                    }
    
                    // Normalize the final score by dividing by totalWeight
                    let finalScore = totalWeight > 0 ? overallScore / totalWeight : 0;
                    lineData.push(finalScore.toFixed(3));
                });
    
                line.name = alternative.alternativeName;
                line.data = lineData;
                line.symbol = lineSymbol[num];
                line.type = "line";
                line.symbolSize = 15;
                line.lineStyle = {
                    width: 4
                };
                num++;
                seriesData.push(line);
            });
        }
    
        // Calculate dynamic min and max for yAxis
        let allValues = seriesData.flatMap(line => line.data.map(Number));
        let minValue = Math.min(...allValues);
        let maxValue = Math.max(...allValues);
        const padding = (maxValue - minValue) * 0.1;
        minValue -= padding;
        minValue = Math.round(minValue * 100) / 100;
        maxValue += padding;
        maxValue = Math.round(maxValue * 100) / 100;
    
        let option = {};
        if (this.state.project.projectAlternatives) {
            let shouldRotate = actorName.some(name => name.length > 30);
            option = {
                title: { text: `Overall result` },
                legend: { top: '5%', textStyle: { fontSize: 16 }},
                tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }},
                toolbox: { feature: { saveAsImage: { title: "Save" }, dataView: { title: "show data", show: true, readOnly: false }}},
                grid: { left: '3%', right: '4%', containLabel: true },
                xAxis: [{ type: 'category', data: actorName, axisLabel: { fontSize: 20, interval: 0, hideOverlap: true }, name: 'Stakeholder group', nameLocation: 'center', nameGap: 25, nameTextStyle: { fontSize: 20, padding: [0, 0, 10, 0] }}],
                yAxis: [{ type: 'value', name: 'Alternative performance/preference', nameLocation: 'center', nameGap: 40, nameTextStyle: { fontSize: 20, padding: [0, 0, 10, 0] }, min: minValue, max: maxValue }],
                series: seriesData
            };
        }
    
        return option;
    };
    
    
    getMAMCAEvaluation = () => {
        let criteriaWeightValue = [];
        let criteriaName = [];
        let lineSymbol = ['circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'];
        let num = 0;
        let evaList = []; // List of evaluators
        let seriesData = [];
    
        if (this.state.project.projectAlternatives) {
            if (this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria && this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.length !== 0) {
                // Gather evaluator list
                this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(criterion => {
                    if (criterion.subCriteria && criterion.subCriteria.length > 0) {
                        criterion.subCriteria.forEach(sub => {
                            sub.actors.forEach(subActor => {
                                if (!evaList.includes(subActor.actorEvaluator)) {
                                    evaList.push(subActor.actorEvaluator);
                                }
                            });
                        });
                    } else {
                        criterion.actors.forEach(actor => {
                            if (!evaList.includes(actor.actorEvaluator)) {
                                evaList.push(actor.actorEvaluator);
                            }
                        });
                    }
                });
    
                // Calculate average weights for criteria and sub-criteria
                this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(criterion => {
                    if (criterion.subCriteria && criterion.subCriteria.length > 0) { // Sub-criteria
                        criterion.subCriteria.forEach(sub => {
                            let subWeightSum = 0;
                            sub.actors.forEach(subActor => {
                                let mainActor = criterion.actors.find(a => a.actorEvaluator === subActor.actorEvaluator);
                                let mainWeight = mainActor ? parseFloat(mainActor.actorCriteriaWeight) : 0;
                                let subWeight = subActor ? parseFloat(subActor.actorSubCriteriaWeight) : 0;
                                subWeightSum += mainWeight * subWeight;
                            });
                            let avgSubWeight = subWeightSum / evaList.length;
                            criteriaWeightValue.push(avgSubWeight.toFixed(3));
                            criteriaName.push(sub.subCriteriaName);
                        });
                    } else { // Main criteria
                        let criterionWeightSum = 0;
                        criterion.actors.forEach(actor => {
                            criterionWeightSum += parseFloat(actor.actorCriteriaWeight);
                        });
                        let avgCriterionWeight = criterionWeightSum / evaList.length;
                        criteriaWeightValue.push(avgCriterionWeight.toFixed(3));
                        criteriaName.push(criterion.criteriaName);
                    }
                });
            }
        }
    
        // Sort criteria by weight (highest to lowest)
        const sortedIndices = criteriaWeightValue
            .map((val, index) => index)
            .sort((a, b) => parseFloat(criteriaWeightValue[b]) - parseFloat(criteriaWeightValue[a]));
    
        criteriaWeightValue = sortedIndices.map(index => criteriaWeightValue[index]);
        criteriaName = sortedIndices.map(index => criteriaName[index]);
    
        // **Add the "Result score" label now to match the final score in lineData**
        criteriaName.push("Result score");
    
        // Calculate alternative scores for each criterion and the final weighted sum score
        this.state.project.projectAlternatives.forEach(alternative => {
            let line = {};
            let lineData = [];
            let overallScore = 0;  // Track final weighted sum score
            let totalWeight = 0;   // Track total weight
    
            this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(criterion => {
                if (criterion.subCriteria && criterion.subCriteria.length > 0) { // Sub-criteria
                    criterion.subCriteria.forEach(sub => {
                        let subScoreSum = 0;
                        sub.actors.forEach(subActor => {
                            subActor.actorSubCriteriaResult.forEach(result => {
                                if (result.subCriteriaAlternativeName === alternative.alternativeName) {
                                    subScoreSum += result.subCriteriaAlternativeScore;
                                }
                            });
                        });
                        let avgSubScore = subScoreSum / evaList.length;
                        let avgSubWeight = parseFloat(criteriaWeightValue[criteriaName.indexOf(sub.subCriteriaName)]);
                        overallScore += avgSubWeight * avgSubScore; // Add weighted score
                        totalWeight += avgSubWeight;
                        lineData.push(avgSubScore.toFixed(3)); // Add average score to lineData
                    });
                } else { // Main criteria
                    let criterionScoreSum = 0;
                    criterion.actors.forEach(actor => {
                        actor.actorCriteriaResult.forEach(result => {
                            if (result.criteriaAlternativeName === alternative.alternativeName) {
                                criterionScoreSum += result.criteriaAlternativeScore;
                            }
                        });
                    });
                    let avgCriterionScore = criterionScoreSum / evaList.length;
                    let avgCriterionWeight = parseFloat(criteriaWeightValue[criteriaName.indexOf(criterion.criteriaName)]);
                    overallScore += avgCriterionWeight * avgCriterionScore; // Add weighted score
                    totalWeight += avgCriterionWeight;
                    lineData.push(avgCriterionScore.toFixed(3)); // Add average score to lineData
                }
            });
    
            // Add the final weighted sum score for each alternative
            let finalScore = totalWeight > 0 ? overallScore : 0; // No need to divide by totalWeight; we want the weighted sum
            lineData.push(finalScore.toFixed(3)); // **Push the final score into lineData**
    
            // Set up the line chart for this alternative
            line.name = alternative.alternativeName;
            line.data = sortedIndices.map(index => lineData[index]); // Reorder line data based on sorted criteria
            line.data.push(finalScore.toFixed(3)); // **Ensure the final result is included in the series data**
            line.symbol = lineSymbol[num];
            line.symbolSize = 12;
            line.type = "line";
            line.lineStyle = { width: 4 };
            seriesData.push(line);
            num++;
        });
    
        // Add the bar chart for the weights
        seriesData.push({
            name: 'Weight value',
            type: 'bar',
            barWidth: '20%',
            itemStyle: {
                color: "#FFF",
                barBorderColor: 1
            },
            data: criteriaWeightValue,
            markPoint: {
                symbol: 'circle',
                symbolSize: 50,
            },
        });
    
        // Return the chart option object
        let option = {};
        if (this.state.project.projectAlternatives) {
            option = {
                title: {
                    text: `Group bird-eye view: ${this.state.project.projectActorGroup[this.state.activeKey - 1].actorGroupName}`
                },
                legend: {
                    top: '5%',
                    textStyle: {
                        fontSize: 16
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                toolbox: {
                    feature: {
                        saveAsImage: { title: "Save" },
                        dataView: { title: "Show data", show: true, readOnly: false }
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    data: criteriaName,
                    axisLabel: {
                        fontSize: 20,
                        interval: 0,
                        hideOverlap: true
                    },
                    name: 'Criterion',
                    nameLocation: 'center',
                    nameGap: 25,
                    nameTextStyle: {
                        fontSize: 20,
                        padding: [0, 0, 10, 0]
                    }
                }],
                yAxis: [{
                    type: 'value',
                    name: 'Alternative score and criterion weight',
                    nameLocation: 'center',
                    nameGap: 25,
                    nameTextStyle: {
                        fontSize: 20,
                        padding: [0, 0, 10, 0]
                    }
                }],
                series: seriesData
            };
        }
    
        return option;
    };
    
    
    
    getMCASensitivityAnalysis = () => {
        let criteriaWeightValue = []
        let criteriaName = []
        let lineSymbol = ['circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow']
        let num = 0
        if (this.state.project.projectAlternatives) { //after loading
            this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(c => {

                criteriaName.push(c.criteriaName)
                c.actors.forEach(cobj => {
                    if (cobj.actorEvaluator === this.state.selectedEvaluator) {
                        if (cobj.actorCriteriaWeight) {
                            criteriaWeightValue.push(cobj.actorCriteriaWeight.toFixed(3))
                        }
                    }
                })
            })

        }
        let seriesData = []
        if (this.state.project.projectAlternatives) {
            this.state.project.projectAlternatives.forEach(obj => {
                let line = {}
                let lineData = []
                line.name = obj.alternativeName
                let finalResult = 0
                this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(c => {
                    let weightNumber

                    if (c.subCriteria && c.subCriteria.length !== 0) { //there is sub-criterion
                        let d = 0

                        c.actors.forEach(a => {
                            if (a.actorEvaluator === this.state.selectedEvaluator) {
                                weightNumber = a.actorCriteriaWeight

                            }
                        })


                        c.subCriteria.forEach(cSub => {
                            cSub.actors.forEach(sobj => {
                                if (sobj.actorEvaluator === this.state.selectedEvaluator) {
                                    sobj.actorSubCriteriaResult.forEach(srobj => {
                                        if (srobj.subCriteriaAlternativeName === obj.alternativeName) {
                                            d += sobj.actorSubCriteriaWeight * srobj.subCriteriaAlternativeScore
                                        }
                                    })
                                }
                            })
                        })


                        lineData.push(d.toFixed(3))
                        finalResult += d * weightNumber
                    }
                    else {
                        c.actors.forEach(aobj => {
                            if (aobj.actorEvaluator === this.state.selectedEvaluator) {
                                aobj.actorCriteriaResult.forEach(raobj => {
                                    if (raobj.criteriaAlternativeName === obj.alternativeName) {

                                        lineData.push(raobj.criteriaAlternativeScore)
                                        finalResult += raobj.criteriaAlternativeScore * aobj.actorCriteriaWeight
                                    }
                                })

                            }


                        })
                    }
                })

                lineData.push(finalResult.toFixed(3))
                line.data = lineData
                line.symbol = lineSymbol[num]
                line.symbolSize = 12
                num++
                line.type = "line"
                line.lineStyle = {
                    width: 4
                }
                seriesData.push(line)
            })
        }
        criteriaName.push("Result score")
        seriesData.push({
            name: 'Weight value',
            type: 'bar',
            barWidth: '20%',
            itemStyle: {
                color: "#FFF",
                barBorderColor: 1
            },
            data: criteriaWeightValue,
            markPoint: {
                symbol: 'circle',
                symbolSize: 50,
            },
        })
        var option = {}
        if (this.state.project.projectAlternatives) {
            option = {
                // color: ['#4C6F74'],
                title: {
                    text: `Actor sensitivity analysis: ${this.state.project.projectActorGroup[this.state.activeKey - 1].actorGroupName}`
                },
                legend: {
                    top: '5%',
                    textStyle: {
                        fontSize: 16 // Set the legend font size here
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: "Save"
                        },
                        dataView: { title: "show data", show: true, readOnly: false },

                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: criteriaName,
                        axisLabel: {
                            fontSize: 20,
                            show: true,
                            interval: 0,
                            hideOverlap: true,
                            // rotate: shouldRotate ? 45 : 0,
                        },
                        name: 'Criterion',
                        nameLocation: 'center',
                        nameGap: 25, // Adjust this value to avoid overlap with the axis label
                        nameTextStyle: {
                            fontSize: 20,
                            padding: [0, 0, 10, 0] // Adjust this value to move the axis name up or down
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: 'Alternative score and criterion weight',
                        nameLocation: 'center',
                        nameGap: 25, // Adjust this value to avoid overlap with the axis label
                        nameTextStyle: {
                            fontSize: 20,
                            padding: [0, 0, 10, 0] // Adjust this value to move the axis name up or down
                        }
                    }
                ],
                series: seriesData
            };
        }
        return option
    }
    getWeightOption = () => {
        let criteriaWeightValue = []
        let criteriaName = []
        let lineSymbol = ['circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow']
        let num = 0
        let boxPlot = []
        var boxPlotData = {}
        let test = []
        let evaList = []//to make the evaluator list
        if (this.state.project.projectAlternatives) { //after loading
            if (this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria && this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.length !== 0) { //there are criteria
                if (this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria[0].subCriteria && this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria[0].subCriteria.length !== 0) { //there are subCriteria
                    this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria[0].subCriteria[0].actors.forEach(subCount => {
                        if (subCount.actorSubCriteriaResult && subCount.actorSubCriteriaResult.length !== 0 && subCount.actorSubCriteriaWeight !== undefined) { //there is evaluation
                            evaList.push(subCount.actorEvaluator) //only count the evaluated result
                        }
                    })
                }
                else { //there is no subCriteria
                    this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria[0].actors.forEach(count => {
                        if (count.actorCriteriaResult && count.actorCriteriaResult.length !== 0 && count.actorCriteriaWeight !== undefined) { //there is evaluation
                            evaList.push(count.actorEvaluator) //only count the evaluated result
                        }
                    })
                }
                this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(c => { //for each criterion
                    let boxSingleData = []
                    criteriaName.push(c.criteriaName)
                    if (c.actors && c.actors.length !== 0) { //there are actors
                        let aWeight = 0
                        c.actors.forEach(cobj => {
                            if (evaList.indexOf(cobj.actorEvaluator) !== -1) {//it's in the list
                                aWeight += cobj.actorCriteriaWeight
                                boxSingleData.push(cobj.actorCriteriaWeight)
                            }
                        })
                        aWeight = aWeight / evaList.length
                        criteriaWeightValue.push(aWeight.toFixed(3))
                        boxPlot.push(boxSingleData)
                    }
                })
            }
            boxPlotData = echarts.dataTool.prepareBoxplotData(boxPlot)
            for (let i = 0; i < boxPlotData.axisData.length; i++) {
                boxPlotData.axisData[i] = this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria[i].criteriaName
            }
            boxPlotData.boxData.forEach(obj => { //array, push the data
                let testSub = []
                obj.forEach(subObj => { //eachData
                    subObj = Number(subObj).toFixed(3)
                    testSub.push(subObj)
                })
                test.push(testSub)
            })
        }
        let seriesData = []

        if (this.state.project.projectAlternatives) {
            this.state.project.projectAlternatives.forEach(obj => {
                let line = {}
                let lineData = []
                line.name = obj.alternativeName
                let overallscore = 0
                this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(c => { //for each criteria
                    if (c.subCriteria && c.subCriteria.length !== 0) { //there is sub-criterion
                        let cWeight = 0 //criterion weight
                        let subResult = 0 //for subcriteria result
                        c.actors.forEach(cobj => {
                            cWeight = cobj.actorCriteriaWeight // evaluator weight
                            c.subCriteria.forEach(subobj => {
                                if (subobj.actors && subobj.actors.length !== 0) { //there is result
                                    subobj.actors.forEach(asubobj => {
                                        if (asubobj.actorEvaluator === cobj.actorEvaluator && evaList.indexOf(asubobj.actorEvaluator) !== -1) { //find the evaluator
                                            asubobj.actorSubCriteriaResult.forEach(rasubobj => {
                                                if (rasubobj.subCriteriaAlternativeName === obj.alternativeName) {
                                                    overallscore = cWeight * asubobj.actorSubCriteriaWeight * rasubobj.subCriteriaAlternativeScore + overallscore // for the final score
                                                    subResult = asubobj.actorSubCriteriaWeight * rasubobj.subCriteriaAlternativeScore + subResult
                                                }

                                            })
                                        }
                                    })
                                }
                            })
                        })

                        subResult = subResult / evaList.length // average criterion score and push

                        lineData.push(subResult.toFixed(3))
                    }
                    else { //only criteria
                        if (c.actors && c.actors.length !== 0) {
                            let aScore = 0
                            c.actors.forEach(aobj => {
                                if (evaList.indexOf(aobj.actorEvaluator) !== -1) { //find the evaluator
                                    aobj.actorCriteriaResult.forEach(raobj => {
                                        if (raobj.criteriaAlternativeName === obj.alternativeName) {
                                            aScore += raobj.criteriaAlternativeScore
                                            overallscore = overallscore + raobj.criteriaAlternativeScore * aobj.actorCriteriaWeight
                                            // lineData.push(raobj.criteriaAlternativeScore)
                                            // finalResult += raobj.criteriaAlternativeScore * aobj.actorCriteriaWeight
                                        }
                                    })
                                }
                            })
                            aScore = aScore / evaList.length
                            lineData.push(aScore.toFixed(3))
                        }
                    }
                })
                overallscore = overallscore / evaList.length
                // lineData.push(overallscore.toFixed(3))
                line.data = lineData
                line.symbol = lineSymbol[num]
                line.symbolSize = 12
                num++
                line.type = "line"
                line.lineStyle = {
                    width: 4
                }
                seriesData.push(line)
            })
        }
        // criteriaName.push("Result score")
        // seriesData.push({
        //     name: 'Average result',
        //     type: 'bar',
        //     barWidth: '20%',
        //     itemStyle: {
        //         color: "#FFF",
        //         barBorderColor: 1
        //     },
        //     data: boxPlotData.boxData, //criteriaWeightValue
        //     markPoint: {
        //         symbol: 'circle',
        //         symbolSize: 50,
        //     },
        // })
        seriesData.push({ //box
            name: 'Weight boxplot',
            type: 'boxplot',
            data: test,
            itemStyle: {
                color: "#FFF",
                borderColor: "#000",
                opacity: 0.5
            },
            // tooltip: {
            //     formatter: function (param) {
            //         return [
            //             'Experiment ' + param.name + ': ',
            //             'upper: ' + param.data[5],
            //             'Q3: ' + param.data[4],
            //             'median: ' + param.data[3],
            //             'Q1: ' + param.data[2],
            //             'lower: ' + param.data[1]
            //         ].join('<br/>');
            //     }
            // }
        })
        seriesData.push({ //extrem value
            name: 'outlier',
            type: 'scatter',
            itemStyle: {
                color: "#FFF",
                barBorderColor: 1
            },
            data: boxPlotData.outliers
        })
        var option = {}
        if (this.state.project.projectAlternatives) {
            option = {
                // color: ['#4C6F74'],
                title: {
                    text: `Actor average result: ${this.state.project.projectActorGroup[this.state.activeKey - 1].actorGroupName}`
                },
                legend: {
                    top: '5%',
                    textStyle: {
                        fontSize: 16 // Set the legend font size here
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: "Save"
                        },
                        dataView: { title: "show data", show: true, readOnly: false },

                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: criteriaName,
                        axisLabel: {
                            fontSize: 20,
                            show: true,
                            interval: 0,
                            hideOverlap: true,
                            // rotate: shouldRotate ? 45 : 0,
                        },
                        name: 'Criterion',
                        nameLocation: 'center',
                        nameGap: 25, // Adjust this value to avoid overlap with the axis label
                        nameTextStyle: {
                            fontSize: 20,
                            padding: [0, 0, 10, 0] // Adjust this value to move the axis name up or down
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: 'Alternative score and criterion weight',
                        nameLocation: 'center',
                        nameGap: 25, // Adjust this value to avoid overlap with the axis label
                        nameTextStyle: {
                            fontSize: 20,
                            padding: [0, 0, 10, 0] // Adjust this value to move the axis name up or down
                        }
                    }
                ],
                series: seriesData
            };
        }
        return option
    }

    
    handleChart() {
        if (this.state.chart === "Evaluation result") {
            return this.getMAMCAEvaluation()
        }
        if (this.state.chart === "Sensitivity analysis") {
            return this.getMCASensitivityAnalysis()
        }
        if (this.state.chart === "Average result") {
            return this.getWeightOption()
        }
        if (this.state.chart === "Overall result") {
            return this.getMAMCAOverallResult()
        }
    }

    onEvents = () => {
        return ({
            click: (params) => { //click event
                if (params.componentSubType === "bar" && this.state.chart === "Sensitivity analysis") {
                    this.setState({
                        changedName: params.name,
                        number: params.data
                    })
                }
                // if (this.state.chart === "Weight analysis") {
                //     this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(obj => {
                //         if (obj.criteriaName === params.name && obj.subCriteria && obj.subCriteria.length !== 0) { //find the criterion, should have criteria group that can be expanded
                //             this.setState({
                //                 selectedCriterion: params.name
                //             })
                //         }
                //     }
                //     )
                // }
            }
        })
    }
    //get the projects
    getProject = () => {
        fetch(`/project/getProject/${this.props.match.params.projectid}/${Cookie.get("email")}/`, { //get the project id from link
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    if (json.project.projectActorGroup && json.project.projectActorGroup.length !== 0) {
                        let menuList = []
                        let selectedEvaluator = Cookie.get("email")
                        if (json.project.projectActorGroup[0].actorCriteria && json.project.projectActorGroup[0].actorCriteria.length !== 0) {
                            if (json.project.projectActorGroup[0].actorCriteria[0].actors && json.project.projectActorGroup[0].actorCriteria[0].actors.length !== 0) { //there are actors          
                                selectedEvaluator = json.project.projectActorGroup[0].actorCriteria[0].actors[0].actorEvaluator
                                json.project.projectActorGroup[0].actorCriteria[0].actors.forEach(aobj => {
                                    let menuItem = (
                                        <Menu.Item key={aobj.actorEvaluator}>
                                            <Icon type="user" />
                                            {aobj.actorEvaluator}
                                        </Menu.Item>
                                    )
                                    menuList.push(menuItem)
                                })
                            }
                        }
                        let menu = ( //evaluator list default
                            <Menu onClick={this.handleMenuClick}>
                                {menuList}
                            </Menu>
                        );

                        let panes = []
                        let index = 1
                        json.project.projectActorGroup.forEach(obj => {
                            panes.push({ title: obj.actorGroupName, key: index, id: obj._id })
                            index++
                        })
                        this.setState({
                            project: json.project,
                            projectName: json.project.projectName,
                            projectType: json.project.projectType,
                            selectedEvaluator: selectedEvaluator,
                            number: 0,
                            changedName: "",
                            loading: false,
                            panes: panes,
                            menu: menu,
                        }) //save project data
                    }
                }
                else {
                    message.error(json.message)
                    this.props.history.push("/"); //redirect to homepage if the project not exist, shouldn't be a case
                }
            });
    }


    downloadExcel = () => {
        const { project } = this.state;
    
        if (!project) return;
    
        const { projectActorGroup, projectAlternatives, projectName, projectDescription, projectCreator, projectEvaluationType, projectTags } = project;
    
        // Prepare the workbook
        let wb = XLSX.utils.book_new();
    
        // Define styles
        const headerStyle = {
            font: { bold: true, color: { rgb: "FFFFFF" } },
            fill: { fgColor: { rgb: "4F81BD" } },
            alignment: { horizontal: "center", vertical: "center" },
            border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
            },
        };
    
        const dataCellStyle = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
            },
            alignment: { horizontal: "center", vertical: "center" },
        };
    
        const getValidSheetName = (name) => {
            return name.length > 31 ? name.slice(0, 28) + '...' : name;
        };
    
        // First tab: General project information
        let generalInfoData = [
            [{ v: 'Project Name:', s: headerStyle }, { v: projectName, s: dataCellStyle }],
            [{ v: 'Project Description:', s: headerStyle }, { v: projectDescription, s: dataCellStyle }],
            [{ v: 'Project Creator:', s: headerStyle }, { v: projectCreator, s: dataCellStyle }],
            [{ v: 'Project EvaluationType:', s: headerStyle }, { v: projectEvaluationType, s: dataCellStyle }],
            [{ v: 'Project Tags:', s: headerStyle }, { v: projectTags, s: dataCellStyle }],
            [],
            [{ v: 'Alternatives', s: headerStyle }, { v: 'Description', s: headerStyle }],
        ];
    
        projectAlternatives.forEach(alt => {
            generalInfoData.push([
                { v: alt.alternativeName, s: dataCellStyle },
                { v: alt.alternativeDescription || '', s: dataCellStyle },
            ]);
        });
    
        generalInfoData.push([]);
    
        projectActorGroup.forEach(actorGroup => {
            generalInfoData.push([{ v: `Actor Group: ${actorGroup.actorGroupName}`, s: headerStyle }]);
            generalInfoData.push([
                { v: 'Criteria/Subcriteria', s: headerStyle },
                { v: 'Main Criterion (if Sub)', s: headerStyle },
                { v: 'Description', s: headerStyle },
                { v: 'Indicator', s: headerStyle },
            ]);
    
            actorGroup.actorCriteria.forEach(criteria => {
                if (Array.isArray(criteria.subCriteria) && criteria.subCriteria.length > 0) {
                    generalInfoData.push([
                        { v: criteria.criteriaName || '', s: dataCellStyle },
                        { v: '/', s: dataCellStyle },
                        { v: criteria.criteriaDescription || '', s: dataCellStyle },
                        { v: criteria.criteriaIndicator || '', s: dataCellStyle },
                    ]);
                    criteria.subCriteria.forEach(subCriteria => {
                        generalInfoData.push([
                            { v: subCriteria.subCriteriaName || '', s: dataCellStyle },
                            { v: criteria.criteriaName || '', s: dataCellStyle },
                            { v: subCriteria.subCriteriaDescription || '', s: dataCellStyle },
                            { v: subCriteria.subCriteriaIndicator || '', s: dataCellStyle },
                        ]);
                    });
                } else {
                    generalInfoData.push([
                        { v: criteria.criteriaName || '', s: dataCellStyle },
                        { v: '/', s: dataCellStyle },
                        { v: criteria.criteriaDescription || '', s: dataCellStyle },
                        { v: criteria.criteriaIndicator || '', s: dataCellStyle },
                    ]);
                }
            });
    
            generalInfoData.push([]);
        });
    
        let generalInfoSheet = XLSX.utils.aoa_to_sheet(generalInfoData);
        XLSX.utils.book_append_sheet(wb, generalInfoSheet, 'Project Overview');
    
        // Actor Group Tabs
        projectActorGroup.forEach(actorGroup => {
            let data = [];
    
            // Headers with styles
            let headers = [{ v: 'Criteria/Subcriteria', s: headerStyle }, 
                           ...projectAlternatives.map(a => ({ v: a.alternativeName, s: headerStyle })), 
                           { v: 'Weight value', s: headerStyle }];
            data.push(headers);
    
            // Loop over criteria and add data for each row
            actorGroup.actorCriteria.forEach(criteria => {
                if (Array.isArray(criteria.subCriteria) && criteria.subCriteria.length > 0) {
                    // Loop through subcriteria
                    criteria.subCriteria.forEach(subCriteria => {
                        // Calculate average weight for subcriteria
                        let totalWeight = 0;
                        let participantCount = subCriteria.actors.length;
                        subCriteria.actors.forEach(subActor => {
                            const mainActor = criteria.actors.find(a => a.actorEvaluator === subActor.actorEvaluator);
                            const mainCriteriaWeight = mainActor ? parseFloat(mainActor.actorCriteriaWeight) : 0;
                            const subCriteriaWeight = subActor ? parseFloat(subActor.actorSubCriteriaWeight) : 0;
                            const finalWeight = mainCriteriaWeight * subCriteriaWeight; // Weighted subcriteria
                            totalWeight += finalWeight;
                        });
                        const avgSubCriteriaWeight = participantCount > 0 ? (totalWeight / participantCount).toFixed(3) : 0;
    
                        // Calculate average scores for alternatives under subcriteria
                        let avgScores = projectAlternatives.map(alt => {
                            let totalScore = 0;
                            subCriteria.actors.forEach(subActor => {
                                const altResult = subActor.actorSubCriteriaResult.find(result => result.subCriteriaAlternativeName === alt.alternativeName);
                                totalScore += altResult ? altResult.subCriteriaAlternativeScore : 0;
                            });
                            return participantCount > 0 ? (totalScore / participantCount).toFixed(3) : ''; // Average score
                        });
    
                        // Create the row for subcriteria
                        let subRow = [
                            { v: subCriteria.subCriteriaName || '', s: dataCellStyle }, // Subcriteria name
                            ...avgScores.map(score => ({ v: score, s: dataCellStyle })),
                            { v: parseFloat(avgSubCriteriaWeight), s: dataCellStyle } // Weight
                        ];
                        data.push(subRow);
                    });
                } else {
                    // If no subcriteria, calculate average for main criteria
                    let totalWeight = 0;
                    let participantCount = criteria.actors.length;
                    let avgScores = projectAlternatives.map(alt => {
                        let totalScore = 0;
                        criteria.actors.forEach(actor => {
                            const altResult = actor.actorCriteriaResult.find(result => result.criteriaAlternativeName === alt.alternativeName);
                            totalScore += altResult ? altResult.criteriaAlternativeScore : 0;
                        });
                        return participantCount > 0 ? (totalScore / participantCount).toFixed(3) : ''; // Average score
                    });
    
                    // Calculate the average weight
                    criteria.actors.forEach(actor => {
                        totalWeight += parseFloat(actor.actorCriteriaWeight) || 0;
                    });
                    const avgCriteriaWeight = participantCount > 0 ? (totalWeight / participantCount).toFixed(3) : 0;
    
                    // Create the row for the main criterion
                    let row = [
                        { v: criteria.criteriaName || '', s: dataCellStyle }, // Criteria name
                        ...avgScores.map(score => ({ v: score, s: dataCellStyle })),
                        { v: parseFloat(avgCriteriaWeight), s: dataCellStyle } // Weight
                    ];
                    data.push(row);
                }
            });
    
            // Final Score Row
            let resultRow = [{ v: 'Final score', s: headerStyle }];
            projectAlternatives.forEach(alt => {
                let finalScore = 0;
                data.forEach(row => {
                    const weight = parseFloat(row[row.length - 1].v); // Weight value is the last element in the row
                    const altScore = parseFloat(row[headers.findIndex(h => h.v === alt.alternativeName)].v); // Alternative score
                    if (!isNaN(weight) && !isNaN(altScore)) {
                        finalScore += altScore * weight;
                    }
                });
                resultRow.push({ v: finalScore.toFixed(3), s: dataCellStyle });
            });
            resultRow.push({ v: '', s: dataCellStyle });
            data.push(resultRow);
    
            // Create the sheet for this actor group
            let ws = XLSX.utils.aoa_to_sheet(data);
            const validSheetName = getValidSheetName(actorGroup.actorGroupName);
    
            // Add the sheet to the workbook
            XLSX.utils.book_append_sheet(wb, ws, validSheetName);
        });
    
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
        saveAs(dataBlob, `${project.projectName}_${projectCreator}.xlsx`);
    };
    
    
    //export template excel
    // downloadTemplate = async () => {
    //     let projectData = {}
    //     let projectAlternatives = {}
    //     let project = {}
    //     let completete = true
    //     try {
    //         const response = await fetch(`/project/getProject/${this.props.match.params.projectid}/${Cookie.get("email")}/`, { //get the project id from link
    //             method: 'GET',
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             },
    //         });
    //         const json = await response.json();
    //         if (json.success) {
    //             project = json.project
    //             projectData = json.project.projectActorGroup
    //             projectAlternatives = json.project.projectAlternatives
    //         }
    //     } catch (error) {
    //         console.error("Error:", error);
    //     }

    //     project.projectActorGroup.forEach(actor => { // Each actor one sheet
    //         // Check if the data is filled
    //         if (Array.isArray(actor.actorCriteria[0].subCriteria) && actor.actorCriteria[0].subCriteria.length > 0) { // Has subcriteriin, so no need to care about criterion
    //             if (Array.isArray(actor.actorCriteria[0].subCriteria[0].actors) && actor.actorCriteria[0].subCriteria[0].actors.length > 0) { // There is actor info
    //                 if (Array.isArray(actor.actorCriteria[0].subCriteria[0].actors[0].actorSubCriteriaResult) && actor.actorCriteria[0].subCriteria[0].actors[0].actorSubCriteriaResult.length > 0) { // There is actor score result
    //                     if (actor.actorCriteria[0].subCriteria[0].actors[0].hasOwnProperty('actorSubCriteriaWeight')) { // There is weight info
    //                         // completete = true // Finally, true
    //                     } else {
    //                         completete = false
    //                     }
    //                 } else {
    //                     completete = false // Finally, false
    //                 }
    //             }
    //             else {
    //                 completete = false // Finally, false
    //             }
    //         } else { // Check criteria
    //             if (Array.isArray(actor.actorCriteria[0].actors) && actor.actorCriteria[0].actors.length > 0) { // There is actor score result
    //                 if (actor.actorCriteria[0].actors[0].hasOwnProperty('actorCriteriaWeight')) { // There is weight info
    //                     if (Array.isArray(actor.actorCriteria[0].actors[0].actorCriteriaResult) && actor.actorCriteria[0].actors[0].actorCriteriaResult.length > 0) {

    //                     } else {
    //                         completete = false
    //                     }
    //                 } else {
    //                     completete = false
    //                 }
    //             } else {
    //                 completete = false
    //             }
    //         }

    //     })

    //     if (completete) { // Can do the work
    //         const doc = new jsPDF();
    //         // Set the font family
    //         doc.setFont("Helvetica"); // Replace "Arial" with the desired font family
    //         // First page
    //         // Add a title to the PDF
    //         doc.setFontSize(24);
    //         doc.text('MAMCA Project report', 70, 30);

    //         // Add the project name and creator
    //         doc.setFontSize(18);
    //         doc.text(`Project Name: ${project.projectName}`, 15, 80);
    //         doc.text(`Project Creator: ${project.projectCreator}`, 15, 95);
    //         doc.text(`Project Description: ${project.projectDescription}`, 15, 110);
    //         // Add a logo
    //         // Fetch the image as a Blob
    //         const response = await fetch('https://res.cloudinary.com/ddwpezn3f/image/upload/v1663771674/VUB/logo-mamca.jpg');
    //         const blob = await response.blob();

    //         // Create an object URL from the Blob
    //         const blobUrl = URL.createObjectURL(blob);

    //         // Add the image to the PDF
    //         doc.addImage(blobUrl, 'JPEG', 15, 10, 50, 50);



    //         // Add the citation text
    //         doc.setFontSize(9);
    //         doc.text('Please cite our MAMCA methodology paper:', 15, 210);
    //         doc.text('https://onlinelibrary.wiley.com/doi/abs/10.1002/atr.5670430206', 15, 220);
    //         doc.text('and MAMCA software paper:', 15, 230);
    //         doc.text('https://www.tandfonline.com/doi/full/10.1080/01605682.2024.2398114', 15, 240);
    //         doc.text('https://link.springer.com/chapter/10.1007/978-3-030-46224-6_4', 15, 250);
    //         doc.text('For more information, please visit:', 15, 260);
    //         doc.text('https://www.mamca.eu/', 15, 270);
    //         // Add a page break
    //         doc.addPage();

    //         // Generate a table for project alternatives on the second page
    //         // Add a title to the PDF
    //         doc.setFontSize(24);
    //         doc.text('Alternative page', 70, 30);
    //         // Add the alternative description
    //         doc.setFontSize(18);
    //         doc.text(`Here is the alternative information table:`, 15, 50);
    //         // Add the table
    //         doc.setFontSize(18);
    //         autoTable(doc, {
    //             startY: 60,
    //             head: [['Alternative Name', 'Description']],
    //             body: project.projectAlternatives.map(alt => [alt.alternativeName, alt.alternativeDescription])
    //         });
    //         let fullData = []
    //         // For each actor group
    //         projectData.forEach(g => {
    //             // Create an array for the table rows
    //             doc.addPage();
    //             doc.setFontSize(18);

    //             doc.text(`Stakeholder group page: ${g.actorGroupName}`, 15, 30);
    //             // Add the alternative description
    //             doc.setFontSize(12);
    //             doc.text(`Here is the criteria table for stakeholder group:`, 15, 50);

    //             const rows = [];

    //             // Iterate over the actorCriteria array
    //             for (const criteria of g.actorCriteria) {
    //                 // Add a row for the criteria
    //                 rows.push({
    //                     criteriaName: criteria.criteriaName,
    //                     subCriteria: '',
    //                     description: criteria.criteriaDescription,
    //                     indicator: criteria.criteriaIndicator,
    //                 });

    //                 // Iterate over the subCriteria array
    //                 for (const subCriteria of criteria.subCriteria) {
    //                     // Add a row for the sub-criteria
    //                     rows.push({
    //                         // criteriaName: 'N/A',
    //                         // description: 'N/A',
    //                         // indicator: 'N/A',
    //                         criteriaName: '',
    //                         subCriteria: subCriteria.subCriteriaName,
    //                         description: subCriteria.subCriteriaDescription,
    //                         indicator: subCriteria.subCriteriaIndicator
    //                     });
    //                 }
    //             }

    //             // Generate the table
    //             doc.autoTable({
    //                 startY: 60,
    //                 head: [['Criterion', 'Sub-criterion', 'Description', 'Indicator',]],
    //                 body: rows.map(row => Object.values(row)),
    //             });


    //             // Set a new data source


    //             let newDataSource = []
    //             if (Array.isArray(g.actorCriteria[0].subCriteria) && g.actorCriteria[0].subCriteria.length > 0) { // Has subcriteriin, so no need to care about criterion
    //                 g.actorCriteria[0].subCriteria[0].actors.forEach((e, index) => {
    //                     let alternativeData = []
    //                     projectAlternatives.forEach(a => {
    //                         alternativeData.push({
    //                             alternativeName: a.alternativeName
    //                         })

    //                     })
    //                     alternativeData.push({
    //                         alternativeName: 'Criterion weight'
    //                     })
    //                     let oneGroup = {
    //                         actorEvaluator: e.actorEvaluator,
    //                         actorResult: alternativeData
    //                     }
    //                     newDataSource.push(oneGroup); // Push the data
    //                 })

    //             } else { // Check criteria
    //                 g.actorCriteria[0].actors.forEach(e => {
    //                     let alternativeData = []
    //                     projectAlternatives.forEach(a => {
    //                         alternativeData.push({
    //                             alternativeName: a.alternativeName
    //                         })

    //                     })
    //                     alternativeData.push({
    //                         alternativeName: 'Criterion weight'
    //                     })
    //                     let oneGroup = {
    //                         actorEvaluator: e.actorEvaluator,
    //                         actorResult: alternativeData
    //                     }
    //                     newDataSource.push(oneGroup); // Push the data
    //                 })
    //             }
    //             // Set criteria weight
    //             g.actorCriteria.forEach(a => { // For each criterion
    //                 if (Array.isArray(a.subCriteria) && a.subCriteria.length > 0) { // Has subcriteriin, so no need to care about criterion
    //                     a.subCriteria.forEach(subC => { // For each subcriterion
    //                         subC.actors.forEach((e) => { // For each actor
    //                             let checkedActor = newDataSource.find(findA => findA.actorEvaluator === e.actorEvaluator)
    //                             e.actorSubCriteriaResult.forEach(r => { // For each alternative result
    //                                 checkedActor.actorResult.find(findAlt => findAlt.alternativeName === r.subCriteriaAlternativeName)[subC.subCriteriaName] = r.subCriteriaAlternativeScore
    //                             })
    //                             let checkedWeight = newDataSource.find(findA => findA.actorEvaluator === e.actorEvaluator)
    //                             let mainWeight = a.actors.find(findA => findA.actorEvaluator === e.actorEvaluator).actorCriteriaWeight
    //                             checkedWeight.actorResult.find(findAlt => findAlt.alternativeName === 'Criterion weight')[subC.subCriteriaName] = e.actorSubCriteriaWeight * mainWeight
    //                         })

    //                     })

    //                 } else { // Check criteria
    //                     a.actors.forEach(e => {
    //                         e.actorCriteriaResult.forEach(r => { // For each alternative result
    //                             newDataSource.find(findA => findA.actorEvaluator === e.actorEvaluator).actorResult.find(findAlt => findAlt.alternativeName === r.criteriaAlternativeName)[a.criteriaName] = r.criteriaAlternativeScore
    //                         })
    //                         newDataSource.find(findA => findA.actorEvaluator === e.actorEvaluator).actorResult.find(findAlt => findAlt.alternativeName === 'Criterion weight')[a.criteriaName] = e.actorCriteriaWeight
    //                     })
    //                 }
    //             })
    //             newDataSource.forEach(actor => {
    //                 // Get the weights for each criterion
    //                 const weights = actor.actorResult.find(result => result.alternativeName === 'Criterion weight');

    //                 actor.actorResult.forEach(result => {
    //                     if (result.alternativeName !== 'Criterion weight') {
    //                         // Calculate the overall score for each alternative
    //                         let overallScore = 0;
    //                         for (let criterion in result) {
    //                             if (criterion !== 'alternativeName' && weights.hasOwnProperty(criterion)) {
    //                                 overallScore += result[criterion] * weights[criterion];
    //                             }
    //                         }
    //                         // Add the overall score to the result
    //                         result['Overall score'] = overallScore.toFixed(3);
    //                     }
    //                 });
    //             });
    //             doc.addPage();
    //             doc.setFontSize(18);
    //             doc.text(`Stakeholder group page: ${g.actorGroupName}`, 15, 30);

    //             let startY = 20; // Initial start position
    //             fullData.push(newDataSource)
    //             newDataSource.forEach((actor, index) => {
    //                 // Add the alternative description
    //                 doc.setFontSize(12);
    //                 doc.text(`Here is the evaluation table of evaluator: ${actor.actorEvaluator}:`, 15, startY + 20);

    //                 const headers = Object.keys(actor.actorResult[0]);
    //                 const rows = actor.actorResult.map(result => {
    //                     const values = Object.values(result);
    //                     // Convert all values to three decimal places
    //                     return values.map(value => typeof value === 'number' ? value.toFixed(3) : value);
    //                 });

    //                 doc.autoTable({
    //                     startY: startY + 30, // Start position for the table
    //                     head: [headers],
    //                     body: rows,
    //                     theme: 'striped',
    //                     styles: { fontSize: 10, cellPadding: 1, overflow: 'linebreak' },
    //                     headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold' }
    //                 });

    //                 // Update startY for the next table
    //                 startY = doc.previousAutoTable.finalY + 20; // Add some space between tables
    //             });

    //         })
    //         let mergedData = [];
    //         fullData.forEach(group => {
    //             let groupMergedData = [];
    //             group.forEach(actor => {
    //                 actor.actorResult.forEach(result => {
    //                     let existingResult = groupMergedData.find(r => r.alternativeName === result.alternativeName);
    //                     if (existingResult) {
    //                         for (let key in result) {
    //                             if (key !== 'alternativeName') {
    //                                 existingResult[key] = existingResult[key] ? (parseFloat(existingResult[key]) + parseFloat(result[key])) / 2 : parseFloat(result[key]);
    //                             }
    //                         }
    //                     } else {
    //                         groupMergedData.push({ ...result });
    //                     }
    //                 });
    //             });
    //             mergedData.push(groupMergedData);
    //         });
    //         let MAMCAheader = ['alternativeName']
    //         projectData.forEach(g => { MAMCAheader.push(g.actorGroupName) })
    //         let MAMCAdata = []
    //         projectAlternatives.forEach(a => {
    //             let newData = {
    //                 alternativeName: a.alternativeName
    //             }
    //             projectData.forEach((g, index) => { // For each group
    //                 newData[g.actorGroupName] = mergedData[index].find(altC => altC.alternativeName === a.alternativeName)['Overall score']
    //             })
    //             MAMCAdata.push(newData)
    //         })
    //         // Generate the table
    //         doc.addPage();
    //         doc.setFontSize(18);
    //         doc.text(`Final Evaluation Table for Stakeholder groups`, 15, 30);
    //         doc.autoTable({
    //             startY: 60,
    //             head: [MAMCAheader],
    //             body: MAMCAdata.map(row => Object.values(row)),
    //         });

    //         // Download the PDF
    //         doc.save('project_report.pdf');
    //     }
    //     else { // There is no data, stop
    //         message.error("The evaluation hasn't completed, please first finish the evaluation!")
    //     }
    // }
    componentDidMount() {
        try {
            this.setState({ activeKey: Cookie.get('activeKey') })
            this.getProject() //after render immediately get alternative list
        } catch (e) {
            alert(e);
        }
    }

    render() {
        const Step = Steps.Step;
        //the step infomation
        const mamcaSteps = [{
            title: 'Alternatives',
        },
        {
            title: 'Actors',
        }, {
            title: 'Criteria',
        }, {
            title: 'Weights',
        }, {
            title: 'Evaluation',
        }, {
            title: 'Result',
        }];
        return <div className="MCACriteria">
            <Spin size="large" tip="Loading..." spinning={this.state.loading}>
                <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                        <h3>{this.state.projectName}</h3>
                </Row>
                <Divider />
                <Steps style={{ width: "80%", margin: "auto" }} current={5} onChange={this.onStepChange}>
                    {mamcaSteps.map(item => <Step key={item.title} title={item.title} />)}
                </Steps>
                <div className="steps-content"></div>
                <Button onClick={() => { this.setState({ chart: "Overall result" }) }} style={{ marginLeft: "0" }} type="primary" size="large">Overall result</Button>
                <Button onClick={() => { this.setState({ chart: "Evaluation result" }) }} style={{ marginLeft: "2vh" }} type="primary" size="large">Group bird's-eye view</Button>
                <Button onClick={() => { this.setState({ chart: "Sensitivity analysis" }) }} style={{ marginLeft: "2vh" }} type="primary" size="large">Sensitivity analysis</Button>
                <Button onClick={() => { this.setState({ chart: "Average result" }) }} style={{ marginLeft: "2vh" }} type="primary" size="large">Average actor group result</Button>
                {/* <Button onClick={this.downloadTemplate} style={{ marginLeft: "2vh" }} size="large">Download MAMCA project report</Button> */}
                <Button onClick={this.downloadExcel} style={{ marginLeft: "2vh" }} size="large">Download all data in Excel</Button>

                <div>&nbsp;</div>
                {(this.state.chart === "Overall result") ? <div></div> : <div><Tabs
                    size={"large"}
                    onChange={this.onChange}
                    activeKey={this.state.activeKey}
                >
                    {this.state.panes.map(pane => <TabPane tab={<span><Icon type="team" />{pane.title}</span>} key={pane.key}></TabPane>)}
                </Tabs>
                </div>
                }
                {(this.state.chart === "Overall result") || (this.state.chart === "Average result") || (this.state.chart === "Evaluation result") ? <div></div> :
                    <div><Dropdown.Button style={{ float: "right" }} type="primary" size="large" overlay={this.state.menu} icon={<Icon type="user" />}>
                        {this.state.selectedEvaluator}
                    </Dropdown.Button>
                        <div>&nbsp;</div>
                    </div>
                }
                <div>&nbsp;</div>
                <ReactEcharts
                    option={this.handleChart()}
                    onEvents={this.onEvents()}
                    style={{ height: '75vh', width: '100%' }}
                />

                {this.state.changedName === "" ? <div></div> :
                    <div>
                        {this.state.chart === "Sensitivity analysis" ?
                            <Form>
                                <Form.Item
                                    label={"Change weight " + this.state.changedName}
                                >
                                    <Row type="flex" justify="start">
                                        <Col span={2}>
                                            <InputNumber
                                                min={0.1}
                                                max={0.9}
                                                step={0.01}
                                                value={this.state.number}
                                                onChange={this.handleNumberChange}
                                            />
                                        </Col>
                                        <Col span={4}>
                                            <Button onClick={this.getProject}>Reset</Button>
                                        </Col>
                                    </Row>
                                </Form.Item>
                            </Form>
                            : <div></div>}
                    </div>}
                {/* {this.state.chart === "Weight analysis" ?
                    <Button onClick={() => { this.setState({ selectedCriterion: "" }) }}>Reset</Button>
                    : <div></div>} */}
                <Divider />
                <div className="steps-action">
                    <Button size="large">
                        <Link to={`/mamcaevaluation/${this.props.match.params.projectid}`}>Previous</Link>
                    </Button>
                </div>
            </Spin>
        </div>;
    }
}